<template>
  <div
    class=""
    v-loading="isLoading"
  >
    <div
      v-if="bidAmountMsg.bid_strategy"
      class="h-[80px]"
    >
      <div v-if="!isEditing">
        {{
          bidAmountMsg.bidAmount
            ? bidAmountMsg.bid_strategy == 'MAX_CONVERSION' || bidAmountMsg.bid_strategy == 'TARGET_CPA'
              ? formatedMoney(bidAmountMsg.bidAmount)
              : `${bidAmountMsg.bidAmount}%`
            : ''
        }}
        <i
          v-if="bidAmountMsg.bidAmount"
          class="el-icon-edit-outline"
          style="cursor: pointer"
          @click="beforeEditBuget()"
        ></i>
      </div>
      <p>
            <el-tag
              v-if="
                (!bidAmountMsg.bidAmount && value.row.campaign_bid_amount && level == 'adset') ||
                (!bidAmountMsg.bidAmount && level == 'campaign')
              "
              type="primary"
              size="mini"
              style="cursor: pointer"
              @click="beforeEditBuget()"
            >
              {{ bidAmountMsg.bid_strategy == 'MAX_CONVERSION' ? '设置目标出价' : '设置目标ROAS' }}
            </el-tag>
      </p>
      <div
        v-if="isEditing"
        class="ad_cell_inline_targetcp"
      >
        <el-form
          :model="formData"
          ref="bidForm"
          :rules="rules"
        >
          <el-form-item prop="editValue">
            <el-input
              size="small"
              v-model="formData.editValue"
              v-cell-focus
              @blur="cancelEditBuget"
              @change="editBid(true)"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span class="color9">{{ bidAmountMsg.bidStrategyName }}</span>
    </div>
  </div>
</template>

<script>
import { updateCampaignBid, cmpaignBudget } from '@/api/google/account.js';
import { mutateBid } from '@/api/google/adManagement';
import { mapGetters } from 'vuex';
import { setTimeEditBid } from '@adCommonComponent';
import { searchBidStrategy } from '@/views/google/createSearchAds';
import { guardOwner } from '@/utils/ownerGuard';
export default {
  name: 'AdCellInlineEditTargetCp',
  components: {},
  directives: {
    'cell-focus': {
      bind(el, binding) {
        // el.focus();
        setTimeout(() => {
          el.children[0].focus();
        }, 200);
      },
    },
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    accountId: {
      type: [String, Array],
      default: '',
    },
    level: {
      type: String,
      default: 'adset',
    },
    userInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    setTimeEditBid,
  },
  data() {
    return {
      oldVal: '',
      isEditing: false,
      editValue: '',
      isLoading: false,
      formData: {
        editValue: '',
      },
      rules: {
        editValue: [
          { required: false, message: '请输入出价金额', trigger: ['blur', 'change'] },
          { validator: this.validateBid, trigger: ['blur', 'change'] },
        ],
      },
    };
  },
  computed: {
    bidAmountMsg() {
      let bid_strategy = this.value.row.bid_strategy || this.value.row.campaign_bid_strategy;
      let msg = {
        bidAmount: this.value.row.bid_amount,
        bidStrategyName: searchBidStrategy.find((v) => v.value == bid_strategy)?.label
          ? `${searchBidStrategy.find((v) => v.value == bid_strategy)?.label}${
              this.value.row.bid_amount ? (bid_strategy == 'MAX_CONVERSION' ? '（目标出价）' : '（目标ROAS）') : ''
            }`
          : bid_strategy == 'TARGET_CPA'
          ? '目标出价'
          : '目标ROAS',
        userCampaignBid: !this.value.row.bid_amount,
        bid_strategy: bid_strategy,
      };
      return msg;
    },
  },
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {
    formatedMoney(v) {
      const currencySign = this.value.row.currency || '$';
      return currencySign + parseFloat(v).toFixed(2);
    },
    async beforeEditBuget(isDaily) {
      if (!(await guardOwner(this.value.row))) return;
      this.oldVal = this.value.row.bid_amount ? parseFloat(this.value.row.bid_amount) : '';
      this.editValue = this.oldVal;
      this.formData.editValue = this.oldVal;
      this.isEditing = true;
    },
    refreshTableRow() {
      const regex = /^\d*(\.\d{0,2})?$/;
      if (regex.test(this.editValue) || this.editValue === '') {
        // Valid input
      } else {
        this.editValue = this.editValue.slice(0, -1);
      }
      console.log(this.value, ' this.value');
      this.$emit('scope-row-changed', this.value);
    },
    refreshTable() {
      this.$emit('get-list');
    },
    cancelEditBuget() {
      if (this.editValue == this.value.row.bid_amount) {
        this.isEditing = false;
        this.refreshTableRow();
      }
    },
    // 设置定时改出价
    setTimeEditBidHandle() {
      this.$refs.setTimeEditBid.dialogVisible = true;
    },

    validateBid(rule, value, callback) {
      //   if (!value) {
      //     callback(new Error('请输入出价金额'));
      //     return;
      //   }
      const decimalRegex = /^\d+(\.\d{1,2})?$/;
      if (value && !decimalRegex.test(value.toString())) {
        callback(new Error('请输入正确的金额格式，最多两位小数'));
        return;
      }

      callback();
    },
    // 修改出价
    editBid() {
      this.$refs.bidForm.validate((valid) => {
        if (!valid) return;

        let scope = this.value;
        let row = scope.row;
        let targetVal = Number(this.formData.editValue);
        let params = {
          customerId: this.accountId.toString(),
          resourceNames: [row.resource_name],
          bidStrategy:
            row.bid_strategy || (row.campaign_bid_strategy == 'MAX_CONVERSION' ? 'TARGET_CPA' : 'TARGET_ROAS'),
          bidAmount: targetVal || null,
          level: row.level,
          oldVal: this.oldVal,
          campaignType: row.campaign_type || row.type,
        };
        this.isLoading = true;
        mutateBid(params)
          .then((res) => {
            this.isLoading = false;
            this.isEditing = false;
            if (res.code == 0) {
              row.bid_amount = targetVal;
              // row.bid_strategy = targetVal ? params.bidStrategy : null;
              row.bid_strategy = !targetVal && this.level == 'adset' ? null : params.bidStrategy;
              this.editValue = targetVal;
            } else {
              this.$message({
                type: 'warning',
                message: '失败了',
              });
            }
            this.refreshTableRow();
          })
          .catch(() => {
            this.isLoading = false;
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ad_cell_inline_targetcp {
  text-align: left;
  :deep(.el-form-item) {
    margin-bottom: 0;
  }
}
</style>
